import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../AxiosInstance";
import qs from "qs";
import { useTranslation } from "react-i18next";
import { URLS } from "../../API/API endpoints";

const SubscriptionRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const [statusMessage, setStatusMessage] = useState(
    "Confirming your payment..."
  );

  // ✅ Helper to check if opened inside WebView
  const isWebView = () => {
    return typeof window.ReactNativeWebView !== "undefined";
  };

  // ✅ Helper to send messages to React Native
  const sendToReactNative = (messageObj) => {
    if (isWebView()) {
      window.ReactNativeWebView.postMessage(JSON.stringify(messageObj));
    }
  };

  useEffect(() => {
    const confirmPayment = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const paymentId = params.get("id");
        const success = params.get("success");
        const orderId = params.get("order");
        if (!paymentId) {
          const errorMsg = "Invalid payment request.";
          setStatusMessage(errorMsg);

          if (isWebView()) {
            sendToReactNative({
              status: "ERROR",
              data: { message: errorMsg },
            });
          } else {
            setTimeout(() => navigate("/settings/subscription"), 3000);
          }
          return;
        }

        if (success === "true") {
          if (isWebView()) {
            sendToReactNative({ status: "SUCCESS" });
          } else {
            setTimeout(() => navigate("/settings/subscription"), 2000);
          }
        } else {
          const cancelMsg = "Payment failed or was cancelled.";
          setStatusMessage(cancelMsg);

          if (isWebView()) {
            sendToReactNative({
              status: "ERROR",
              data: { message: cancelMsg },
            });
          } else {
            setTimeout(() => navigate("/settings/subscription"), 2000);
          }
        }
      } catch (err) {
        console.error("Payment confirmation error:", err);
        const errorMsg = "An error occurred while confirming your payment.";
        setStatusMessage(errorMsg);

        if (isWebView()) {
          sendToReactNative({
            status: "ERROR",
            data: { message: errorMsg, error: err.message },
          });
        } else {
          setTimeout(() => navigate("/settings/subscription"), 2000);
        }
      }
    };

    confirmPayment();
  }, [navigate]);

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-50">
      <div className="bg-white p-8 rounded-2xl shadow-lg text-center w-[90%] max-w-md">
        <h1 className="text-2xl font-semibold mb-4">{t("Paymob Payment")}</h1>
        {status ? (
          <p className="text-gray-600">{t("Payment successful")}</p>
        ) : (
          <p className="text-gray-600">{t(statusMessage)}</p>
        )}
      </div>
    </div>
  );
};

export default SubscriptionRedirect;
